module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-668b9d53c2432b89251c06f00dc47a12.webp";